var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.976,
    height: 17.955,
    viewBox: "0 0 17.976 17.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.478-5.467a.51.51,0,0,1,.707,0L2.936-2.76A2.625,2.625,0,0,0,4.8-1.986h.531L1.92,1.427a2.784,2.784,0,0,1-3.86,0L-5.368-2h.327A2.625,2.625,0,0,0-3.175-2.77l2.7-2.7ZM.229-8.054a.5.5,0,0,1-.707,0l-2.7-2.7a2.5,2.5,0,0,0-1.867-.773h-.327l3.424-3.426a2.732,2.732,0,0,1,3.864,0l3.417,3.415H4.8a2.625,2.625,0,0,0-1.867.773Zm-5.27-2.679a1.907,1.907,0,0,1,1.3.541l2.7,2.7a1.439,1.439,0,0,0,.918.38A1.438,1.438,0,0,0,.791-7.5L3.5-10.2a1.868,1.868,0,0,1,1.3-.538H6.128l2.05,2.05a2.731,2.731,0,0,1,0,3.86l-2.05,2.05H4.8a1.856,1.856,0,0,1-1.3-.541L.791-6.029a1.324,1.324,0,0,0-1.832,0l-2.7,2.693a1.907,1.907,0,0,1-1.3.541H-6.16L-8.2-4.83a2.728,2.728,0,0,1,0-3.86l2.04-2.043Z",
    transform: "translate(9 15.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixIcon);
export default __webpack_public_path__ + "static/media/pix-icon.64b07b93752c778f3fbbefbec1ca9e60.svg";
export { ForwardRef as ReactComponent };